<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 苹果风格的全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #f5f5f7;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: #1d1d1f;
  line-height: 1.47059;
  font-weight: 400;
  letter-spacing: -0.022em;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
  background-color: #f5f5f7;
}

/* 覆盖Element Plus主题色变量 */
:root {
  --el-color-primary: #475569 !important;
  --el-color-primary-light-3: #6b7280 !important;
  --el-color-primary-light-5: #9ca3af !important;
  --el-color-primary-light-7: #d1d5db !important;
  --el-color-primary-light-8: #e5e7eb !important;
  --el-color-primary-light-9: #f3f4f6 !important;
  --el-color-primary-dark-2: #374151 !important;
}

/* 重置Element Plus样式以符合苹果风格 */
.el-button {
  border-radius: 12px !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  letter-spacing: -0.022em !important;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
}

.el-button--primary {
  background-color: #475569 !important;
  border-color: #475569 !important;
  color: #ffffff !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: #374151 !important;
  border-color: #374151 !important;
}

.el-input__wrapper {
  border-radius: 12px !important;
  border: 1px solid #d2d2d7 !important;
  background-color: #ffffff !important;
  font-size: 17px !important;
  padding: 12px 16px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
}

.el-input__wrapper:hover {
  border-color: #475569 !important;
  box-shadow: 0 0 0 3px rgba(71, 85, 105, 0.1) !important;
}

.el-input__wrapper.is-focus {
  border-color: #475569 !important;
  box-shadow: 0 0 0 3px rgba(71, 85, 105, 0.15) !important;
}

.el-input__inner {
  color: #1d1d1f !important;
  font-weight: 400 !important;
  letter-spacing: -0.022em !important;
}

.el-input__inner::placeholder {
  color: #86868b !important;
  font-weight: 400 !important;
}

.el-form-item__label {
  color: #1d1d1f !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  letter-spacing: -0.022em !important;
}

.el-message {
  border-radius: 12px !important;
  font-weight: 500 !important;
  letter-spacing: -0.022em !important;
}

.el-input-number {
  width: 100% !important;
}

.el-input-number .el-input__wrapper {
  padding-right: 50px !important;
}

/* 覆盖单选按钮等组件的主题色，保持复选框为淡蓝色 */
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

.el-checkbox__input.is-checked:hover .el-checkbox__inner {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background-color: #475569 !important;
  border-color: #475569 !important;
}

.el-radio__input.is-checked:hover .el-radio__inner {
  border-color: #374151 !important;
}

.el-radio__input.is-checked .el-radio__inner::after {
  background-color: #ffffff !important;
}

.el-select .el-input__wrapper.is-focus {
  border-color: #475569 !important;
  box-shadow: 0 0 0 3px rgba(71, 85, 105, 0.15) !important;
}

.el-select-dropdown__item.is-selected {
  color: #475569 !important;
}

.el-select-dropdown__item:hover {
  background-color: rgba(71, 85, 105, 0.1) !important;
}

/* Tab 组件样式覆盖 */
.el-tabs__active-bar {
  background-color: #475569 !important;
}

.el-tabs__item.is-active {
  color: #475569 !important;
}
</style> 